const inr = new Intl.NumberFormat("en-IN", { maximumFractionDigits: 0 });
const inr2 = new Intl.NumberFormat("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 });

export const rs = (v) => `${v < 0 ? "-" : ""}₹${inr.format(Math.abs(Math.round(v || 0)))}`;
export const rs2 = (v) => `${v < 0 ? "-" : ""}₹${inr2.format(Math.abs(v || 0))}`;
export const num = (v) => inr.format(v || 0);
export const qty = (v) => (Number.isInteger(v) ? inr.format(v) : (v || 0).toFixed(1));
export const pct = (v) => `${((v || 0) * 100).toFixed(1)}%`;

const pad = (n) => String(n).padStart(2, "0");
export const iso = (d) => `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
export const todayIso = () => iso(new Date());
export const monthOf = (isoDate) => isoDate.slice(0, 7);
export const daysInMonth = (ym) => {
  const [y, m] = ym.split("-").map(Number);
  return new Date(y, m, 0).getDate();
};
export const fmtDate = (s, opts = { day: "2-digit", month: "short" }) =>
  new Date(`${s}T00:00:00`).toLocaleDateString("en-IN", opts);
export const fmtMonth = (ym) =>
  new Date(`${ym}-01T00:00:00`).toLocaleDateString("en-IN", { month: "long", year: "numeric" });
export const addDays = (s, n) => {
  const d = new Date(`${s}T00:00:00`);
  d.setDate(d.getDate() + n);
  return iso(d);
};
